import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const OK = (props: any) => {

  // TODO: take props
  const handleClose = props.handleClose;

  // TODO: redux
  const data = useSelector((state: any) => state.appReducer.data);

  // TODO: navigate
  const navigate = useNavigate();

  // TODO: onClickConfirm
  const _onClickConfirm = () => {
    sessionStorage.setItem("answer", JSON.stringify(data.result))
    navigate("/confirm", { replace: true });
  }

  return (
    <div className="flex flex-col w-full h-max">
      {/* title */}
      <div className="flex justify-between text-white pl-3 pr-3 items-center w-full h-[2.5rem] bg-primary rounded-t-md">
        <p>Xác nhận câu trả lời</p>
      </div>

      {/* content */}
      <div className="flex flex-col w-full h-max p-3">
        <p>Chào {data.name},</p>
        <p>Bạn đã hoàn tất 20 câu hỏi.</p> <br />
        <p>Nhấn "Xác nhận" để tiếp tục hoặc "Đóng" để kiểm tra lại. Cảm ơn {data.name}.</p> <br />

        <div className="flex space-x-3 mt-7 justify-end items-center w-full h-max">
          <button onClick={_onClickConfirm} className="text-white flex rounded-md justify-center items-center w-[6rem] h-[1.75rem] bg-sky-600 hover:bg-sky-500">
            Xác nhận
          </button>

          <button onClick={handleClose} className="flex rounded-md justify-center items-center w-[5rem] h-[1.75rem] bg-slate-300 hover:bg-slate-200">
            Đóng
          </button>
        </div>
      </div>
    </div>
  )
}

export default OK;
